var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1C7.37 1 6.92508 1.445 6.70508 2H2.5V14.5H13.5V2H9.29492C9.07492 1.445 8.63 1 8 1ZM8 2C8.275 2 8.5 2.225 8.5 2.5V3H10V4H6V3H7.5V2.5C7.5 2.225 7.725 2 8 2ZM3.5 3H5V5H11V3H12.5V13.5H3.5V3ZM4.5 6.5V7.5H5.5V6.5H4.5ZM6.5 6.5V7.5H11.5V6.5H6.5ZM4.5 8.5V9.5H5.5V8.5H4.5ZM6.5 8.5V9.5H11.5V8.5H6.5ZM4.5 10.5V11.5H5.5V10.5H4.5ZM6.5 10.5V11.5H11.5V10.5H6.5Z",
    fill: "#303335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardListIcon);
export default __webpack_public_path__ + "static/media/clipboardListIcon.8880a6ba1335128dbad1eb21ef9e8d6d.svg";
export { ForwardRef as ReactComponent };